RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const MAX_TICKS = 15; // maximum number of ticks we'll draw. Too many and the numbers run into each other.
    const LINE_CHART_HEIGHT = 200;

    const Line = RivalIQ.apps.Dashboard.widgets.LineChart.extend({
        getTooltip: function () {
            const me = this;

            return {
                title: function (data, index) {
                    const model = me.collection.first();
                    const numStories = model.getValue({
                        format: false
                    }).length;
                    return `${index + 1} of ${numStories}`;
                },

                content: function (data) {
                    const viewOptions = {
                        collection: new RivalIQ.collections.MetricDefinitions(me.collection.map(function (metric, i) {
                            const value = data[0].value[i];

                            return new RivalIQ.models.MetricDefinition(_.extend(metric.toJSON(), {
                                value: metric.format(value)
                            }));
                        }))
                    };

                    return new RivalIQ.apps.Dashboard.widgets.MetricSummaryTooltip(viewOptions).render().el.outerHTML;
                }
            };
        },

        getTickValues: function () {

            const me = this;
            return me.getTicks();
        },

        getChartAttributes: function () {
            const me = this;

            const attrs = _.defaults({
                tooltip: (me.getTooltip ? me.getTooltip() : null),
                showComparePeriod: false,
                labels: {
                    x: 'Frame'
                },
                height: LINE_CHART_HEIGHT
            }, RivalIQ.apps.Dashboard.widgets.LineChart.prototype.getChartAttributes.apply(me, arguments));

            attrs.ticks = Math.min(attrs.data[0].length, MAX_TICKS);
            const metric = attrs.metrics.at(0);
            if (metric.getType() === RivalIQ.enums.dataType.ABSOLUTE_PERCENT) {
                attrs.yMax = 1;
            }

            return attrs;
        }
    });

    const LineChartWidget = RivalIQ.apps.Dashboard.widgets.MetricLineChartWidget.extend({
        view: Line
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_STORY_ORDER_LINE_CHART, LineChartWidget);


    const ReachView = RivalIQ.views.LayoutView.mixin({
        template: '#instagramStoryDayWidgetTemplate',
        childView: RivalIQ.apps.Dashboard.views.Widget,

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        regions: {
            summaryMetric: '.x-summary-metric',
            summaryRateMetric: '.x-summary-rate-metric',
            lineChart: '.x-line-chart'
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            me.summaryMetric.showWidget(me.dashboardModel.getWidget('summary-metric'));
            me.summaryRateMetric.showWidget(me.dashboardModel.getWidget('summary-rate-metric'));
            me.lineChart.showWidget(me.dashboardModel.getWidget('line-chart'));
        },

        serializeData: function () {
            const me = this;

            return {
                chartMetricName: me.dashboardModel.chartMetricName,
                showLegend: me.dashboardModel.showLegend
            };
        }
    });

    const ReachImpressionsWidget = RivalIQ.apps.Dashboard.models.Widget.extend({

        propsToSerializeForExport: [],

        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,
        scheduledExportAdvancedSettingsEnabled: false,

        title: 'Frame Impressions & Reach',
        description: RivalIQ.strings.instagram_insights_frame_reach_impressions_description,
        view: ReachView,
        viewMore: false,

        chartMetricName: 'Impressions & Reach By Frame',
        showLegend: true,

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                objectType: RivalIQ.enums.insightsObjectType.storyDay,
                limit: 200
            });

            if (!me.metric) {
                me.metric = App.utils.createInsightsMetric('storyDay', _.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'storyOrder']
                }, props));
            }

            _.extend(me.metric, props);

            return props;
        },

        widgetDefinitions: function () {
            const me = this;

            const graphMetric = new RivalIQ.models.MetricDefinition(me.metric);
            const storyDayMetric = new RivalIQ.models.MetricDefinition(RivalIQ.metric.build(me.metric, {
                limit: 200,
                dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'storyDay']
            }, {
                clobberDimensions: true
            }));
            const compareMetric = App.utils.buildStoryDayCompareMetric(storyDayMetric);

            return [
                {
                    instanceId: 'summary-metric',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: storyDayMetric.build({
                        property: 'reach_per_story'
                    }),
                    submetric: compareMetric.build({
                        property: 'reach_per_story'
                    }),
                    props: {
                        doNotRebuildMetrics: true
                    }
                },
                {
                    instanceId: 'summary-rate-metric',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: storyDayMetric.build({
                        property: 'view_frequency'
                    }),
                    submetric: compareMetric.build({
                        property: 'view_frequency'
                    }),
                    props: {
                        doNotRebuildMetrics: true
                    }
                },
                {
                    instanceId: 'line-chart',
                    widgetId: RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_STORY_ORDER_LINE_CHART,
                    metrics: new RivalIQ.collections.MetricDefinitions([
                        graphMetric.build({
                            property: 'reach',
                            colorIndex: 2
                        }),
                        graphMetric.build({
                            property: 'impressions',
                            colorIndex: 0
                        })
                    ])
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_STORY_DAY_REACH_IMPRESSIONS, ReachImpressionsWidget);


    const RetentionWidget = RivalIQ.apps.Dashboard.models.Widget.extend({

        propsToSerializeForExport: [],

        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,
        scheduledExportAdvancedSettingsEnabled: false,

        title: 'Frame Completion Rate',
        description: RivalIQ.strings.instagram_insights_frame_retention_rate_description,
        view: ReachView,
        viewMore: false,

        chartMetricName: 'Completion Rate By Frame',
        showLegend: false,

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                objectType: RivalIQ.enums.insightsObjectType.storyDay,
                limit: 200
            });

            if (!me.metric) {
                me.metric = App.utils.createInsightsMetric('storyDay', _.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'storyOrder']
                }, props));
            }

            _.extend(me.metric, props);

            return props;
        },

        widgetDefinitions: function () {
            const me = this;

            const graphMetric = new RivalIQ.models.MetricDefinition(me.metric);
            const storyDayMetric = new RivalIQ.models.MetricDefinition(RivalIQ.metric.build(me.metric, {
                limit: 200,
                dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'storyDay']
            }, {
                clobberDimensions: true
            }));
            const compareMetric = App.utils.buildStoryDayCompareMetric(storyDayMetric);

            return [
                {
                    instanceId: 'summary-metric',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: storyDayMetric.build({
                        property: 'completion_rate_per_story'
                    }),
                    submetric: compareMetric.build({
                        property: 'completion_rate_per_story'
                    }),
                    props: {
                        doNotRebuildMetrics: true
                    }
                },
                {
                    instanceId: 'summary-rate-metric',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: storyDayMetric.build({
                        property: 'stories_retention_rate'
                    }),
                    submetric: compareMetric.build({
                        property: 'stories_retention_rate'
                    }),
                    props: {
                        doNotRebuildMetrics: true
                    }
                },
                {
                    instanceId: 'line-chart',
                    widgetId: RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_STORY_ORDER_LINE_CHART,
                    metrics: new RivalIQ.collections.MetricDefinitions([
                        graphMetric.build({
                            name: 'Completion Rate',
                            property: 'completion_rate',
                            colorIndex: 1
                        })
                    ])
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_STORY_DAY_RETENTION_RATE, RetentionWidget);
});
